import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_addition_component = _resolveComponent("item-addition-component")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    persistent: "",
    "no-shake": "",
    "full-width": "",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_item_addition_component, {
        "existing-position-id": _ctx.existingPositionId,
        onClose: _ctx.handleClose
      }, null, 8, ["existing-position-id", "onClose"])
    ]),
    _: 1
  }, 8, ["onHide"]))
}